
<template>
  <div class="bannerSlider" v-if="slidesAvailable">
    <v-container no-gutters class="pt-0 pb-0">
      <v-row justify="center">
        <v-col cols="12" class="pa-0">
          <vueper-slides
            v-if="ready"
            autoplay
            :bullets="false"
            :arrows="false"
            :slideRatio="$store.state.advertising.banner.aspectRatio"
            :transition-speed="$store.state.advertising.banner.transitionSpeed"
            :duration="$store.state.advertising.banner.duration"
          >
            <vueper-slide
              v-for="(slide, i) in slides"
              :key="i"
              :image="slide.image"
              class="improveImageRendering"
            >
              <template v-slot:content>
                <div
                  class="vueperslide__content-wrapper"
                  style="flex-direction: row"
                  @click.stop="onSlideClicked(slide)"
                ></div>
              </template>
            </vueper-slide>
          </vueper-slides>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "BannerAdvertisingSlideContent",
  components: { VueperSlides, VueperSlide },
  data: function () {
    return {
      ready: false,
      slides: [],
    };
  },
  mounted: function () {
    var mediaList = this.$store.state.advertising.banner.media;
    if (mediaList) {
      var newSlides = [];
      mediaList.forEach((med) => {
        newSlides.push({ image: med.url, link: med.link });
      });
      // duplicate media if there is only one
      if (newSlides.length == 1) {
        newSlides.push(newSlides[0]);
      }
      this.slides = newSlides;
      this.ready = true;
    }
  },
  computed: {
    slidesAvailable: function () {
      return (
        this.slides.length > 0
      );
    },
  },
  methods: {
    onSlideClicked: function (slide) {
      console.log("onSlide clicked", slide);
      var url = slide.link;
      if (!url) {
        return;
      }
      this.$common.openExternalLink(url);
    },
  },
};
</script>
<style scoped>
.bannerSlider >>> .vueperslides .vueperslide__title {
  color: white; /* var(--v-accent-base); */
}
.bannerSlider >>> .vueperslides__bullets,
.bannerSlider >>> .vueperslides__arrows {
  color: var(--v-secondary-base);
}

.bannerSlider >>> .vueperslides .vueperslide__content-wrapper {
  justify-content: flex-end;
}

.improveImageRendering {
  image-rendering: -webkit-optimize-contrast;
}
</style>